import React from "react";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Table } from "semantic-ui-react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { TableSearchFilter } from "../common/TableSearchFilter";

const tableWithPagination = (keyField, columns, rows, onColumnMatch) => (
  <ToolkitProvider
    keyField={keyField}
    data={rows}
    columns={columns}
    search={{
      defaultSearch: "",
      searchFormatted: true,
      onColumnMatch: (e) => onColumnMatch(e),
    }}
  >
    {(props) => (
      <div className={"padding-top-10"}>
        <Table className={"table-no-border-and-padding"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <TableSearchFilter {...props.searchProps} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <BootstrapTable
          className={"padding-top-10"}
          keyField={keyField}
          hover
          striped
          pagination={paginationFactory({
            sizePerPage: 25,
            showTotal: true,
            paginationTotalRenderer: (from, to, size) => (
              <span className="react-bootstrap-table-pagination-total">
                Showing {from} to {to} of {size} Results
              </span>
            ),
          })}
          {...props.baseProps}
        />
      </div>
    )}
  </ToolkitProvider>
);

export default tableWithPagination;



// WEBPACK FOOTER //
// ./src/components/common/TableWithPagination.js